const TOKEN_KEY = `token_${process.env.REACT_APP_ID}`;
const CATALOG_TOKEN_KEY = `catalog-token_${process.env.REACT_APP_ID}`;
const REFRESH_TOKEN_KEY = `refresh_${process.env.REACT_APP_ID}`;
const MODE_KEY = `mode_${process.env.REACT_APP_ID}`;
const EXPIRATION_KEY = `expires_${process.env.REACT_APP_ID}`;
const CATALOG_EXPIRATION_KEY = `catalog-expires_${process.env.REACT_APP_ID}`;
const OPERATION_UUID = `operation-uuid_${process.env.REACT_APP_ID}`;
const EXTERNAL_UUID = `external-uuid_${process.env.REACT_APP_ID}`;
const STATIC_CONTENT = `static-content_${process.env.REACT_APP_ID}`;
const STATIC_CONTENT_REQUESTED = `static-content-requested_${process.env.REACT_APP_ID}`;
const RETRIES = `retries_${process.env.REACT_APP_ID}`;
const REDIRECT = `redirect_${process.env.REACT_APP_ID}`;
const CODE = `code_send_${process.env.REACT_APP_ID}`;
const VERSION = 'APP_VERSION';

const getToken = (): string | null => localStorage.getItem(TOKEN_KEY);
const getCodeSent = (): string | null => localStorage.getItem(CODE);
const getCatalogToken = (): string | null => localStorage.getItem(CATALOG_TOKEN_KEY);
const getRefresh = (): string | null => localStorage.getItem(REFRESH_TOKEN_KEY);
const getMode = (): string | null => localStorage.getItem(MODE_KEY);
const getExpirationDate = (): string | null => localStorage.getItem(EXPIRATION_KEY);
const getCatalogExpirationDate = (): string | null => localStorage.getItem(CATALOG_EXPIRATION_KEY);
const getOperationUuid = (): string | null => localStorage.getItem(OPERATION_UUID);
const getExternalUuid = (): string | null => localStorage.getItem(EXTERNAL_UUID);
const getStaticContent = (): string | null => localStorage.getItem(STATIC_CONTENT);
const getStaticContentRequested = (): string | null => localStorage.getItem(STATIC_CONTENT_REQUESTED);
const getAppVersion = (): string | null => localStorage.getItem(VERSION);
const getRetries = (): string | null => localStorage.getItem(RETRIES);
const getRedirect = (): string | null => localStorage.getItem(REDIRECT);

const setToken = (token: string): void => localStorage.setItem(TOKEN_KEY, token);
const setCodeSent = (token: string): void => localStorage.setItem(CODE, token);
const setCatalogToken = (token: string): void => localStorage.setItem(CATALOG_TOKEN_KEY, token);
const setRefreshToken = (token: string): void => localStorage.setItem(REFRESH_TOKEN_KEY, token);
const setMode = (mode: 'client' | 'user'): void => localStorage.setItem(MODE_KEY, mode);
const setExpirationDate = (timestamp: string): void => localStorage.setItem(EXPIRATION_KEY, timestamp);
const setCatalogExpirationDate = (timestamp: string): void => localStorage.setItem(CATALOG_EXPIRATION_KEY, timestamp);
const setOperationUuid = (uuid: string): void => localStorage.setItem(OPERATION_UUID, uuid);
const setExternalUuid = (uuid: string): void => localStorage.setItem(EXTERNAL_UUID, uuid);
const setStaticContent = (content: string): void => localStorage.setItem(STATIC_CONTENT, content);
const setStaticContentRequested = (timestamp: string): void =>
  localStorage.setItem(STATIC_CONTENT_REQUESTED, timestamp);
const setRetries = (qty: string) => localStorage.setItem(RETRIES, qty);
const setRedirect = (url: string) => localStorage.setItem(REDIRECT, url);

const cleanRetries = (): void => localStorage.removeItem(RETRIES);
const cleanRedirect = (): void => localStorage.removeItem(REDIRECT);
const cleanMode = (): void => localStorage.removeItem(MODE_KEY);

export {
  getToken,
  getCodeSent,
  getCatalogToken,
  getRefresh,
  getMode,
  getExpirationDate,
  getCatalogExpirationDate,
  getOperationUuid,
  getExternalUuid,
  getStaticContent,
  getStaticContentRequested,
  getRetries,
  getRedirect,
  getAppVersion,
  setToken,
  setCodeSent,
  setCatalogToken,
  setRefreshToken,
  setMode,
  setExpirationDate,
  setCatalogExpirationDate,
  setOperationUuid,
  setExternalUuid,
  setStaticContent,
  setStaticContentRequested,
  setRetries,
  setRedirect,
  cleanRetries,
  cleanRedirect,
  cleanMode,
};
